import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { APP_NAME, APP_STAGE } from "./config";
import "./styles.css";
import "./styles/tokens.css";
import "./styles/answer-moment.css";
import "./styles/bottom-nav.css";

document.title = `${APP_NAME} · ${APP_STAGE}`;

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if ("serviceWorker" in navigator && location.protocol !== "file:") {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => undefined);
  });
}
